import { publicPageUrl } from "../utils/publicPages";
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="footer">
      <Container>
        <Row>
          <Col md={4}>
            <h5>{t("footer.company")}</h5>
            <ul>
              <li>
                <a href={publicPageUrl(i18n.language, "about")}>{t("footer.about")}</a>
              </li>
              <li>
                <a href={publicPageUrl(i18n.language, "career")}>{t("footer.career")}</a>
              </li>
              <li>
                <a href={publicPageUrl(i18n.language, "team")}>{t("footer.team")}</a>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <h5>{t("footer.more")}</h5>
            <ul>
              <li>
                <a href={publicPageUrl(i18n.language, "terms")}>{t("footer.terms")}</a>
              </li>
              <li>
                <a href={publicPageUrl(i18n.language, "privacy")}>{t("footer.privacy")}</a>
              </li>
              <li>
                <a href={publicPageUrl(i18n.language, "advertise")}>{t("footer.advertise")}</a>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <h5>{t("navbar.communication")}</h5>
            <ul>
              <li>
                <a href="mailto:support@augenarzt.cloud">
                  {t("navbar.contact_us")}
                </a>
              </li>
              <li>
                <a href={publicPageUrl(i18n.language, "help")}>
                  {t("navbar.help")}
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
